import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@/design-system/atoms/button/button.component';
import { IconComponent } from '@/design-system/atoms/icon/icon.component';

@Component({
  selector: 'app-topbar-actions',
  imports: [ButtonComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './topbar-actions.component.scss',
  templateUrl: './topbar-actions.component.html',
})
export class TopbarActionsComponent {
  buttonIcon = input.required<string>();
  buttonLabel = input.required<string>();
  buttonLoading = input(false);

  buttonClick = output();
}
